export default function metaRobotsIndex(content) {
  let mtag = document.querySelector("[name='robots']");
  if (!mtag) {
    mtag = document.createElement("meta");
    mtag.setAttribute("name", "robots");
    mtag = document.getElementsByTagName("head")[0].appendChild(mtag);
  }

  mtag.setAttribute("content", content);
}
